import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { Microservices } from '../constants/pol.enums';

export interface IHeliosRolesResponse {
  roles: string[];
}

@Injectable({
  providedIn: 'root',
})
export class HeliosSsoAuthService {
  private http = inject(HttpClient);
  private router = inject(Router);

  public getHeliosRoles(): import('rxjs').Observable<IHeliosRolesResponse | null> {
    const apiUrl = `${Microservices.Authorization}/subjects/me/evaluate`;
    return this.http.post<IHeliosRolesResponse>(apiUrl, {}).pipe(
      map((response) => response),
      catchError(() => {
        this.router.navigateByUrl('error').catch(() => undefined);
        return of(null);
      })
    );
  }
}
